module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reach"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": "",
      "lg12": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card-text', [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("How to Reach Meherabad")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Meherabad")]), _vm._v(" is located on Daund Road six kilometers outside the city of Ahmednagar, Maharashtra State, India. ")])]), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Travel By Air")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The nearest airports are at Pune and Aurangabad, both approximately two and one half hours from Ahmednagar by road. The nearest international airport is Mumbai, approximately five hours by road to Ahmednagar.")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Travel by Rail")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Located on the Daund/Manmad railway line, Ahmednagar is accessible by rail from many Indian cities, both to the north and south, including Delhi, Bangalore, and Hyderabad. Local rail service to/from Pune and Mumbai is not generally convenient as the trains are slow. ")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Travel by Car")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Buses and taxis reach Ahmednagar from Pune, Aurangabad, Sholapur, and Nasik. A direct road from Mumbai, which bypasses Pune, takes about five hours in light traffic.")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xl12": "",
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "d-flex": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xl6": "",
      "lg6": "",
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.samadhi
    }
  }, [_c('v-icon', [_vm._v("location_on")]), _vm._v("Samadhi")], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xl6": "",
      "lg6": "",
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.mpr
    }
  }, [_c('v-icon', [_vm._v("location_on")]), _vm._v("MPR")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xl12": "",
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "d-flex": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xl6": "",
      "lg6": "",
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.mpc
    }
  }, [_c('v-icon', [_vm._v("location_on")]), _vm._v("MPC")], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "xl6": "",
      "lg6": "",
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.hosteld
    }
  }, [_c('v-icon', [_vm._v("location_on")]), _vm._v("Hostel-D")], 1)], 1)], 1), _vm._v(" "), _vm._v("\r\n\t\t\t \r\n\t\t\t"), _vm._v("\r\n\t\t\t \r\n\t\t\t")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc7472d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/air.vue
// module id = 316
// module chunks = 1